import { consumer } from '@tock/coretypes';
import { getDisplayComponentForWidget } from 'utils/widgetUtils';
import React from 'react';

export interface WidgetSpecificParams {
  onChangeIsShopHeroInView?(inView: boolean): void;
  isWineShop?: boolean;
}

export interface WidgetCreatorContentProps {
  widget: consumer.Widget;
  widgetSpecificParams?: WidgetSpecificParams;
  pageWidgetListIndex: number;
  options: {
    lazyLoad?: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fetchMoreWidgetData: any;
    type: consumer.ConsumerPageType;
    slug: string;
    pathname: string;
    className?: string;
    isTitle: boolean;
  };
}

const WidgetCreatorContent: React.FunctionComponent<WidgetCreatorContentProps> = ({
  widget,
  widgetSpecificParams,
  pageWidgetListIndex,
  options,
}) => {
  return (
    getDisplayComponentForWidget(
      widget,
      widgetSpecificParams ?? {},
      pageWidgetListIndex,
      options
    ) ?? null
  );
};

export default WidgetCreatorContent;
